export default __webpack_public_path__ + "static/media/scipy.2990a3f3.png";